var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRiseLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 28,
    viewBox: "0 0 109 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0549 24.1106H65.7221V3.88849H61.0549V24.1106Z",
    fill: "#505050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4037 21.2683L74.7522 17.9783C76.1793 19.4693 78.4062 20.724 81.2097 20.724C83.5906 20.724 84.7482 19.6233 84.7482 18.4656C84.7482 14.8694 73.0433 17.3386 73.0433 9.68501C73.0433 6.30226 75.9684 3.49963 80.7556 3.49963C83.9869 3.49963 86.6688 4.47263 88.6778 6.33201L86.2716 9.50301C84.6266 7.97963 82.4321 7.27876 80.3583 7.27876C78.4972 7.27876 77.4594 8.10126 77.4594 9.32101C77.4594 12.5524 89.1389 10.3885 89.1389 17.9783C89.1389 21.697 86.4833 24.4996 80.9979 24.4996C77.0946 24.4996 74.2919 23.188 72.4037 21.2683Z",
    fill: "#505050"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5 24.107V3.88483H108.5V7.9702H98.7105V11.9331H108.294V15.7026H98.7105V19.8326H108.5V24.107H94.5Z",
    fill: "#505050"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0282 8.14926H47.5774C49.2417 8.14926 50.5962 9.47926 50.5962 11.1759C50.5962 12.8436 49.1988 14.2016 47.5451 14.2016H42.0282V8.14926ZM54.8338 11.1759C54.8338 7.1649 51.5779 3.88452 47.5774 3.88452H37.7223V24.1066H42.0282V18.4664H46.3262L49.6144 24.1066H54.6133L50.8578 17.6649C53.215 16.453 54.8338 13.9969 54.8338 11.1759Z",
    fill: "#505050"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3.9375C8.442 3.9375 3.9375 8.442 3.9375 14C3.9375 19.558 8.442 24.0625 14 24.0625C19.558 24.0625 24.0625 19.558 24.0625 14C24.0625 8.442 19.558 3.9375 14 3.9375ZM8.3125 14C8.3125 10.8588 10.8587 8.31253 14 8.31253C17.1412 8.31253 19.6875 10.8588 19.6875 14C19.6875 17.1413 17.1412 19.6875 14 19.6875C10.8587 19.6875 8.3125 17.1413 8.3125 14Z",
    fill: "#FFA31D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 23.8438C8.56363 23.8438 4.15625 19.4364 4.15625 14C4.15625 8.56363 8.56363 4.15625 14 4.15625C19.4364 4.15625 23.8438 8.56363 23.8438 14C23.8438 19.4364 19.4364 23.8438 14 23.8438ZM14 0C6.26763 0 0 6.26763 0 14C0 21.7324 6.26763 28 14 28C21.7324 28 28 21.7324 28 14C28 6.26763 21.7324 0 14 0Z",
    fill: "#FFA31D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiseLogo);
export default __webpack_public_path__ + "static/media/rise-logo.4e7e54d86bf740157178b8b810cb7453.svg";
export { ForwardRef as ReactComponent };